// extracted by mini-css-extract-plugin
module.exports = {"centerbg":"centerView_centerbg__VahSG","center_box_img":"centerView_center_box_img__1X9e-","hide":"centerView_hide__2ij7C"};